import React from 'react';
import PropTypes from 'prop-types';

import AddAssignmentModal from '../AddAssignmentModal';
import { AssignmentRole } from '../../../../utils/internalAssignments';

import texts from './texts';

const RemoveFromPoolModal = ({ coach, onClose, onRemoved }) => (
  <AddAssignmentModal
    role={AssignmentRole.ASSISTANT_COACH}
    coachName={coach.name}
    coachId={coach.id}
    isOpen
    onClose={onClose}
    onAssigned={onRemoved}
    description={texts.description}
    isLiaison={false}
    skipPoolRemovalConfirmation
  />
);

RemoveFromPoolModal.propTypes = {
  coach: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onRemoved: PropTypes.func.isRequired,
};

export default RemoveFromPoolModal;
